<template>
    <div class="grid justify-items-center p-24" role="status">
        <div class="lds-grid" aria-hidden="true">
            <div></div>
            <div></div>
            <div></div>
        </div>
        <span class="sr-only">Loading&hellip;</span>
    </div>
</template>

<script>
export default {}
</script>

<style scoped>
.lds-grid {
    display: inline-block;
    position: relative;
    width: 140px;
    height: 36px;
}
.lds-grid div {
    position: absolute;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #999;
    animation: lds-grid 1.2s linear infinite;
}
.lds-grid div:nth-child(1) {
    top: 16px;
    left: 16px;
    animation-delay: 0s;
}
.lds-grid div:nth-child(2) {
    top: 16px;
    left: 56px;
    animation-delay: -0.4s;
}
.lds-grid div:nth-child(3) {
    top: 16px;
    left: 96px;
    animation-delay: -0.8s;
}
@keyframes lds-grid {
    0%,
    100% {
        opacity: 1;
    }
    50% {
        opacity: 0.5;
    }
}
</style>
